import { render } from "./Comment.vue?vue&type=template&id=2302eeaa&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "./Comment.vue?vue&type=style&index=0&id=2302eeaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2302eeaa"

export default script